import React, {useMemo} from 'react';
import TextField from "@material-ui/core/TextField";
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
    DatePicker
} from '@material-ui/pickers';
import weekday from 'dayjs/plugin/weekday';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {isToday, setDefaultOptions} from "date-fns";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {StaticDatePicker} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const { zonedTimeToUtc, utcToZonedTime, format } = require('date-fns-tz');
const { parse } = require('date-fns');

setDefaultOptions({ weekStartsOn: 1 });
dayjs.extend(weekday)


function DatepickerStatic(props) {
    const { disabled, field, input, meta: { touched, error } } = props;

    if (field.type === 'number') {
        input.min = 1;
    }

    const value = input.value ? dayjs(input.value, 'YYYY-MM-DD') : input.value === 'error' ? 'error' : null;

    const change = (value) => {
        input.onChange(dayjs(value).format('YYYY-MM-DD'));
    }

    const input2 = {
        ...input,
        onChange: change,
    }

    const year = useMemo(() => dayjs().year(), []);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticDatePicker
                {...input2}
                value={value}
                shouldDisableDate={field?.shouldDisableDate ? field.shouldDisableDate : field.preventWeekends ? (date) => date.getDay() === 0 || date.getDay() === 6 || isToday(date) : false }
                error={touched && error}
                helperText={touched && error }
                showToolbar={false}
                componentsProps={{ actionBar: { actions: [  ] }}}
                // shouldDisableYear={(date) => date.getFullYear() < year }
                disablePast
            />
        </LocalizationProvider>
        // <MuiPickersUtilsProvider utils={DateFnsUtils}>
        //     <DatePicker
        //         //disableToolbar
        //         //openTo="year"
        //         //variant="inline"
        //         inputVariant="outlined"
        //         format="dd.MM.yyyy"
        //         id="date-picker-inline"
        //         label={field.required ? <>{field.label} *</> : field.label}
        //         KeyboardButtonProps={{
        //             'aria-label': 'change date',
        //         }}
        //         autoOk={true}
        //         disablePast={field.allowPast ? false : true}
        //         //maxDate={new Date()}
        //         i//nitialFocusedDate={new Date('1990-01-01T00:00:00.000')}
        //         {...input2}
        //         InputLabelProps={{
        //             shrink: value,
        //         }}
        //         value={value}
        //         invalidDateMessage={<span>Invalid</span>}
        //         error={touched && error}
        //         helperText={touched && error }
        //         inline
        //         shouldDisableDate={field?.shouldDisableDate ? field.shouldDisableDate : field.preventWeekends ? (date) => date.getDay() === 0 || date.getDay() === 6 || isToday(date) : false }
        //         disableToolbar={field.allowToolbar ? false : true}
        //         variant="inline"
        //         maxDate={field.maxDate}
        //     />
        // </MuiPickersUtilsProvider>
    );
}

export default DatepickerStatic;
